export const inputClass = (hasError = false): string => {
  const base =
    'w-full rounded-lg border px-3 py-2 text-sm transition-colors outline-none ' +
    'bg-[var(--color-surface)] text-[var(--color-ink)] ' +
    'placeholder:text-[var(--color-ink-mute)] ' +
    'focus:ring-2 focus:ring-[var(--color-accent-tint)] focus:border-[var(--color-accent)]';

  if (hasError) {
    return `${base} border-[var(--color-bad)]`;
  }

  return `${base} border-[var(--color-line-strong)]`;
};
